import React from 'react'
import Header from '../../../components/Dashboard/Header';
import MyIdeabar from '../../../components/Dashboard/Innovator/MyIdeabar';

function Myideas() {
  return (
    <div className='bg-[#F3F4FF] min-h-screen'>
      <Header/>
      <MyIdeabar/>
    </div>
  )
}

export default Myideas
